var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33203 21.6668C4.33203 13.4958 4.33203 9.41031 6.87044 6.8719C9.40885 4.3335 13.4944 4.3335 21.6654 4.3335H30.332C38.503 4.3335 42.5885 4.3335 45.127 6.8719C47.6654 9.41031 47.6654 13.4958 47.6654 21.6668V23.8335C47.6654 29.9618 47.6654 33.0259 45.7616 34.9297C43.8578 36.8335 40.7936 36.8335 34.6654 36.8335H17.332C11.2038 36.8335 8.13964 36.8335 6.23584 34.9297C4.33203 33.0259 4.33203 29.9618 4.33203 23.8335V21.6668Z",
    stroke: "#513117",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6654 47.6665H17.332",
    stroke: "#513117",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36.8332L26 47.6665",
    stroke: "#513117",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6654 28.1665H4.33203",
    stroke: "#513117",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.3b152db9328d2d5082cdc22ab854ae22.svg";
export { ForwardRef as ReactComponent };